import { MultistepRoot } from "./MulstistepRoot";
import { MultistepStep } from "./MultistepStep";

const Multistep = Object.assign(MultistepRoot, {
  Step: MultistepStep,
});

export { Multistep };
